import axios from 'axios'
import * as R from 'ramda'
import { load_one, load_many } from '@/store/action-helpers'

// noinspection JSUnusedGlobalSymbols
export default {

    loadAllByJobId: load_many('jobs/:jobId/offers'),
    loadAllByVariantId: load_many('variants/:variantId/offers'),
    loadOne: load_one('offers/:id'),

    /**
     * Erstellt einen kurzlebigen SSE-Einmal-Token auf dem jobs-Service.
     * Das Token wird beim Öffnen der EventSource-Verbindung als Query-Parameter übergeben.
     */
    getSseToken() {
        return axios.post('/api/v1/sse-token').then(response => response.data.token)
    },

    create({ dispatch }, { model }) {
        return R.pipeP(

            // Angebot speichern
            R.partial(axios.post, ['/api/v1/offers']),

            // Relationen laden
            R.converge(
                Array.of,
                [
                    // Angebot laden
                    ({ data }) => dispatch('loadOne', { id: data.id, force: true }),

                    // Job laden
                    ({ data }) => dispatch('jobs/loadOne', { id: data.job, force: true }, { root: true }),
                ]
            ),

            // Preis-Model lesen
            R.head,

            // Preis-IDs lesen
            R.prop('prices'),

            // Preise laden
            R.map(id => dispatch('prices/loadOne', { id }, { root: true })),

            // Promises zusammenfassen
            promises => Promise.all(promises)

        )(model)
    },

    loadAllByJobModels({ dispatch }, { jobModels, force }) {
        return R.compose(

            // Promises zusammenfassen
            promises => Promise.all(promises).then(R.flatten),

            // Angebote laden
            R.map(jobId => dispatch('loadAllByJobId', { jobId, force })),

            // Job-IDs einlesen
            R.map(R.prop('id')),

        )(jobModels)
    },

    loadAllByIds({ dispatch }, { ids, force }) {
        return R.compose(

            // Promises zusammenfassen
            promises => Promise.all(promises),

            // Angebote laden
            R.map(id => dispatch('loadOne', { id, force })),

        )(ids)
    },

    update({ dispatch }, { model }) {
        return axios.put(`/api/v1/offers/${model.id}`, model).then(() => {

            // Angebot aktualiseren
            return dispatch('loadOne', { id: model.id, force: true }).then(offer => {
                // Preise aktualisieren
                const promises = offer.prices
                    .map(id => dispatch('prices/loadOne', { id }, { root: true }))

                return Promise.all(promises)
            })

        })
    },

}
